var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      ref: "files",
      attrs: {
        drag: "",
        action: "",
        "file-list": _vm.stored,
        "auto-upload": false,
        "on-change": _vm.fileChangeHandler,
        "on-preview": _vm.download
      }
    },
    [
      _c("i", { staticClass: "el-icon-upload" }),
      _vm._v(" "),
      _c("div", { staticClass: "el-upload__text" }, [
        _vm._v("Drop file here or "),
        _c("em", [_vm._v("click to upload")])
      ]),
      _vm._v(" "),
      _vm.tip
        ? _c(
            "div",
            {
              staticClass: "el-upload__tip",
              attrs: { slot: "tip" },
              slot: "tip"
            },
            [_vm._v(_vm._s(_vm.tip))]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a92822f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a92822f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/shared/file/file-upload.vue
// module id = null
// module chunks = 